import { ConcurrentFileModificationError, EmptyFsClient as _EmptyFsClient, FileAccessService, FileNotFoundError, FsClient } from "./index.mjs";
import { Injectable } from "@gitlab/needle";
import * as fs from "fs";
import { chmod, lstat, mkdir, readFile, readlink, rename, stat, unlink, writeFile } from "node:fs/promises";
import { realpathSync } from "node:fs";
import { randomBytes } from "node:crypto";
import { basename, dirname, isAbsolute, join, resolve } from "node:path";
import { Logger, withPrefix } from "@gitlab-org/logging";
import { homedir } from "node:os";
//#region src/node/fs_client.ts
let _initClass$1;
function _applyDecs$1(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$1(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$1(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$1(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$1(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$1(t) {
	var i = _toPrimitive$1(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$1(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$1(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$1(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
let _DesktopFsClient;
(class extends _EmptyFsClient {
	static {
		[_DesktopFsClient, _initClass$1] = _applyDecs$1(this, [Injectable(FsClient, [])], [], 0, void 0, _EmptyFsClient).c;
	}
	promises = {
		readFile: fs.promises.readFile.bind(fs),
		writeFile: fs.promises.writeFile.bind(fs),
		unlink: fs.promises.unlink.bind(fs),
		readdir: fs.promises.readdir.bind(fs),
		mkdir: fs.promises.mkdir.bind(fs),
		rmdir: fs.promises.rmdir.bind(fs),
		stat: fs.promises.stat.bind(fs),
		lstat: fs.promises.lstat.bind(fs),
		access: fs.promises.access.bind(fs),
		chmod: fs.promises.chmod.bind(fs),
		readlink: fs.promises.readlink.bind(fs),
		symlink: fs.promises.symlink.bind(fs),
		readFileFirstBytes: this.#readFileFirstBytes
	};
	async #readFileFirstBytes(filePath, bytes) {
		const buffer = Buffer.alloc(bytes);
		const fileHandle = await fs.promises.open(filePath, "r");
		try {
			const { bytesRead } = await fileHandle.read(buffer, 0, bytes);
			return buffer.subarray(0, bytesRead).toString("utf8");
		} finally {
			await fileHandle.close();
		}
	}
	static {
		_initClass$1();
	}
});
//#endregion
//#region src/node/fs_file_access_service.ts
let _initClass;
function _applyDecs(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey(t) {
	var i = _toPrimitive(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
const handleFileErrorAndThrow = (path) => (e) => {
	if (e !== null && typeof e === "object" && "code" in e && e.code === "ENOENT") throw new FileNotFoundError(path, e);
	throw e;
};
let _FsFileAccessService;
(class {
	static {
		[_FsFileAccessService, _initClass] = _applyDecs(this, [Injectable(FileAccessService, [Logger])], []).c;
	}
	priority = 1;
	#logger;
	#fileLocks = /* @__PURE__ */ new Map();
	constructor(logger) {
		this.#logger = withPrefix(logger, "[FsFileAccessService]");
	}
	async getText(fullPath) {
		return readFile(fullPath, "utf-8").catch(handleFileErrorAndThrow(fullPath));
	}
	async updateFile(fullPath, textEdits, expectedContent) {
		const targetPath = await this.#resolveSymlinkTarget(fullPath);
		await this.#withFileLock(targetPath, async () => {
			const currentContent = await this.getText(targetPath);
			if (expectedContent !== void 0 && currentContent !== expectedContent) throw new ConcurrentFileModificationError(fullPath);
			this.#validateNonOverlappingEdits(currentContent, textEdits);
			const updatedContent = this.#getUpdatedContent(currentContent, textEdits);
			const fileStat = await stat(targetPath).catch(handleFileErrorAndThrow(targetPath));
			await this.#atomicWriteFile(targetPath, updatedContent, fileStat.mode);
		});
	}
	async writeFile(fullPath, newContent) {
		const targetPath = await this.#resolveSymlinkTarget(fullPath);
		await mkdir(dirname(targetPath), { recursive: true });
		await this.#withFileLock(targetPath, () => this.#atomicWriteFile(targetPath, newContent));
	}
	async #atomicWriteFile(targetPath, content, mode) {
		const tmpPath = join(dirname(targetPath), `.${basename(targetPath)}.${randomBytes(6).toString("hex")}.tmp`);
		let tmpFileCreated = false;
		try {
			await writeFile(tmpPath, content);
			tmpFileCreated = true;
			await rename(tmpPath, targetPath);
			if (mode !== void 0) await chmod(targetPath, mode & 4095);
		} catch (error) {
			if (tmpFileCreated) await unlink(tmpPath).catch((cleanupError) => {
				this.#logger.error(`Failed to remove orphaned temp file ${tmpPath}`, cleanupError);
			});
			throw error;
		}
	}
	async #resolveSymlinkTarget(fullPath, checkedPaths = /* @__PURE__ */ new Set()) {
		if (checkedPaths.has(fullPath) || !await this.#isSymbolicLink(fullPath)) return resolve(fullPath);
		checkedPaths.add(fullPath);
		const link = await readlink(fullPath);
		const resolvedLink = isAbsolute(link) ? link : resolve(dirname(fullPath), link);
		return this.#resolveSymlinkTarget(resolvedLink, checkedPaths);
	}
	async #withFileLock(fullPath, fn) {
		const previous = this.#fileLocks.get(fullPath) ?? Promise.resolve();
		let release = () => {};
		const current = new Promise((res) => {
			release = res;
		});
		this.#fileLocks.set(fullPath, current);
		await previous;
		try {
			return await fn();
		} finally {
			release();
			if (this.#fileLocks.get(fullPath) === current) this.#fileLocks.delete(fullPath);
		}
	}
	/**
	* Apply an array of TextEdits to the current content of a file.
	*/
	#getUpdatedContent(currentContent, textEdits) {
		const sortedEdits = [...textEdits].sort((a, b) => {
			const aOffset = this.#positionToOffset(currentContent, a.range.start);
			return this.#positionToOffset(currentContent, b.range.start) - aOffset;
		});
		let result = currentContent;
		for (const edit of sortedEdits) {
			const startOffset = this.#positionToOffset(result, edit.range.start);
			const endOffset = this.#positionToOffset(result, edit.range.end);
			result = result.slice(0, startOffset) + edit.newText + result.slice(endOffset);
		}
		return result;
	}
	#validateNonOverlappingEdits(content, textEdits) {
		if (textEdits.length <= 1) return;
		const offsetRanges = textEdits.map((edit) => {
			return {
				start: this.#positionToOffset(content, edit.range.start),
				end: this.#positionToOffset(content, edit.range.end),
				edit
			};
		});
		offsetRanges.sort((a, b) => a.start - b.start);
		for (let i = 0; i < offsetRanges.length - 1; i++) {
			const current = offsetRanges[i];
			const next = offsetRanges[i + 1];
			if (current.end > next.start) throw new Error(`Overlapping text edits detected: edit at ${current.start}-${current.end} overlaps with edit at ${next.start}-${next.end}`);
		}
	}
	#positionToOffset(content, position) {
		const parts = content.split(/(\r\n|\r|\n)/);
		let offset = 0;
		let currentLine = 0;
		if (position.line < 0) return Math.max(0, position.character);
		for (let i = 0; i < parts.length; i++) {
			const part = parts[i];
			const isNewline = part === "\n" || part === "\r\n" || part === "\r";
			if (currentLine === position.line && !isNewline) {
				const clampedCharacter = Math.max(0, Math.min(position.character, part.length));
				return offset + clampedCharacter;
			}
			offset += part.length;
			if (isNewline) currentLine++;
		}
		if (currentLine === position.line) return offset + Math.max(0, position.character);
		return content.length;
	}
	async realPath(fullPath, checkedPaths = /* @__PURE__ */ new Set()) {
		try {
			if (!checkedPaths.has(fullPath) && await this.#isSymbolicLink(fullPath)) {
				checkedPaths.add(fullPath);
				const link = await readlink(fullPath);
				const resolvedLink = isAbsolute(link) ? link : resolve(dirname(fullPath), link);
				return await this.realPath(resolvedLink, checkedPaths);
			}
			return realpathSync(fullPath);
		} catch (e) {
			const error = e;
			if (error.code === "ENOENT" || error.code === "ENOTDIR") return error.path ?? "";
			return "";
		}
	}
	async #isSymbolicLink(fullPath) {
		try {
			return (await lstat(fullPath)).isSymbolicLink();
		} catch {
			return false;
		}
	}
	static {
		_initClass();
	}
});
//#endregion
//#region src/node/path_utils.ts
/**
* Expands a leading `~` to the user's home directory.
*
* Client-configured paths are not shell-expanded: neither environment variables nor IDE settings
* sent over `didChangeConfiguration` go through a shell, so `~` reaches us literally.
*/
function expandHomeDir(inputPath) {
	return /^~($|[/\\])/.test(inputPath) ? join(homedir(), inputPath.slice(1)) : inputPath;
}
//#endregion
export { _DesktopFsClient as DesktopFsClient, _FsFileAccessService as FsFileAccessService, expandHomeDir };

//# sourceMappingURL=node.mjs.map